import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { assessmentLists } from "../features/assessmentSlice";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import Grid from "@mui/material/Grid";
import {
  getWorkSpaceData,
  setFinalWorkspaceData,setAssessmentId
} from "../features/workspaceDataSlice";
import ErrorHandler from "./ErrorHandler";
import Loader from "./Loader";

import NewAssessmentPopup from "./NewAssessmentPopup";

import PaginationItem from "@mui/material/PaginationItem";
import { BsCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import { grey } from "@mui/material/colors";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import { useEffect } from "react";
import { setIsNewAssessment } from "../features/flagSlice";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const AssessmentList = () => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const {
    assessmentDataLoading,
    assessmentData,
    assessmentDataError,
    assessmentDataSuccess,
  } = useSelector((state) => state.assessment);
  const {
    getWorkspaceDataLoading,
    getWorkspaceDataSuccess,
    getWorkspaceDataError,
    workspaceDataSaveLoading,
  } = useSelector((state) => state.workspaceData);

  const { userInfo, accessToken, role } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const [rowClicked, setRowClicked] = useState(false);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  const handleRowClick = (params) => {
    setRowClicked(true);
    const id = params.id;

    const data = {
      id: id,
      accessToken: accessToken,
    };
    dispatch(setAssessmentId(id))
    dispatch(getWorkSpaceData(data));
  };

  useEffect(() => {
    if (getWorkspaceDataSuccess && rowClicked) {
      dispatch(setIsNewAssessment(false));
      dispatch(setFinalWorkspaceData([]));
      navigate("/workspace");
    }
  }, [getWorkspaceDataSuccess]);
  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <>
       
        <Pagination
          color="primary"
          variant="outlined"
          shape="rounded"
          page={page + 1}
          count={pageCount}
          // @ts-expect-error
          renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </>
    );
  }

  const columns = [
    {
      field: "project_name",
      headerName: "Project Name",
      width: 120,
      //renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "region",
      headerName: "Region",
      width: 150,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "project_type",
      headerName: "Type",
      width: 150,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "building_area",
      headerName: "Building Area (GFA/GIA)",
      sortable: false,
      width: 80,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "construction_end_date",
      headerName: "Anticipated Project Completion Date",
      sortable: false,
      width: 100,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "project_target_carbon_intensity",
      headerName: "Carbon Intensity",
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <>
          {params.value ? (
            <div variant="subtitle2">{params.value}</div>
          ) : (
            <div variant="subtitle2">NA </div>
          )}
        </>
      ),
    },
    {
      field: "project_target_carbon_reduction_percent",
      headerName: "Carbon Reduction Percentage",
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <>
          {params.value ? (
            <div variant="subtitle2">{params.value}</div>
          ) : (
            <div variant="subtitle2">NA </div>
          )}
        </>
      ),
    },

    {
      field: "performance",
      headerName: "Performance",
      sortable: false,
      width: 100,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "climate_action_risk_color",
      headerName: "Climate Action Risk (LoA)",
      headerName: "Climate Action Risk (LoA)",
      sortable: false,
      width: 80,
      renderCell: (params) => (
        <>
          {params.value == "Red" ? (
            <Grid container justifyContent="center" alignItems="center">
              <BsCircleFill
                style={{ color: "red", justifyContent: "center" }}
              />
            </Grid>
          ) : params.value == "Yellow" ? (
            <Grid container justifyContent="center" alignItems="center">
              <BsCircleFill
                style={{ color: "yellow", justifyContent: "center" }}
              />
            </Grid>
          ) : params.value == "Green" ? (
            <Grid container justifyContent="center" alignItems="center">
              <BsCircleFill
                style={{ color: "green", justifyContent: "center" }}
              />
            </Grid>
          ) : (
            "NA"
          )}
        </>
      ),
    },
    {
      field: "design_stages",
      headerName: "Design Stages",
      sortable: false,
      width: 120,
      //renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      width: 100,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      sortable: false,
      width: 200,
      renderCell: (params) => <div variant="subtitle2">{params.value} </div>,
    },
  ];

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  }));

  const CustomNoRowsOverlay = () => {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Available</Box>
      </StyledGridOverlay>
    );
  };

  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5,
    };
  }, []);

  const handleRowEnter = (params) => {
    //setHoveredRowId(params.id);
  };

  const handleRowLeave = () => {
    //setHoveredRowId(null);
  };

  useEffect(() => {
    const data = {
      role: "Admin",
      email: userInfo.email,
      accessToken: accessToken,
    };

    dispatch(assessmentLists(data));
    sessionStorage.removeItem("assessmentId");
  }, []);
  


  return (
    <>
      
      <Backdrop open={workspaceDataSaveLoading}>
        <CircularProgress color="inherit" style={{ zIndex: 9999 }} />
      </Backdrop>
      <Backdrop open={assessmentDataLoading}>
        <CircularProgress color="inherit" style={{ zIndex: 9999 }} />
      </Backdrop>
      
      <>
        <Box
          sx={{ width: "100%" }}
          style={{ maxWidth: "95%", margin: "0px auto" }}
        >
          <Typography
            style={{ fontFamily: "RalewayMedium" }}
            variant="h4"
            gutterBottom
            sx={{
              mt: "35px",
              mb: 2,
              fontWeight: 500,
              fontSize: "24px",
              lineHeight: "32px",
            }}
          >
            Welcome to your Lendlease Embodied Carbon Advisor
          </Typography>
          {!assessmentDataError && (
            <>
              <Tabs value="tabone">
                <Tab
                  value="tabone"
                  label="All Global "
                  sx={{
                    textTransform: "none",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                />
                <Tab value="tabtwo" label="" />
                <Tab value="tabthree" label="" sx={{ mr: "auto" }} />
                <NewAssessmentPopup />
              </Tabs>

              <Box style={{ width: "100%" }}>
                <DataGrid
                  key={assessmentData.id}
                  rows={assessmentData}
                  columns={columns}
                  className="assesment-table"
                  getRowSpacing={getRowSpacing}
                  onRowClick={handleRowClick}
                  onRowEnter={handleRowEnter}
                  onRowLeave={handleRowLeave}
                  style={{
                    fontFamily: "RalewayRegular",
                    padding: "8px 25px",
                    boxShadow:
                      "-2px 0px 6px rgba(0, 0, 0, 0.15), 2px 2px 6px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                  }}
                  sx={{
                    [`& .${gridClasses.row}`]: {
                      bgcolor: (theme) =>
                        theme.palette.mode === "light" ? "#F3F3F3" : grey[200],
                      borderRadius: "8px",
                      marginTop: "0px!important",
                      marginBottom: "7px!important",
                      border: "0px",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      color: "#394E54",
                      fontFamily: "RalewaySemiBold",
                      fontSize: "12px",
                      border: "0px",
                    },
                    "& .MuiDataGrid-cell": {
                      fontFamily: "RalewaySemiBold",
                      fontSize: "12px",
                      lineHeight: "16px",
                      color: "#394E54",
                      border: "0px",
                    },

                    "& .MuiTablePagination-selectLabel": {
                      fontFamily: "RalewaySemiBold",
                      fontSize: "12px",
                      lineHeight: "16px",
                      color: "#394E54",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      variant: "outlined",
                      shape: "rounded",
                    },
                    "& .MuiPaginationItem-root": {
                      borderRadius: 2,
                      backgroundColor: "#D9D9D9",
                    },
                    "& .MuiDataGrid-row:hover": {
                      cursor: "pointer",
                    },
                    mt: 2,
                    mb: 2,
                  }}
                  
                  slots={{
                    pagination: CustomPagination,
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 20 },
                    },
                  }}
                  pageSizeOptions={[20, 40]}
                />
                <Backdrop open={getWorkspaceDataLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
                
              </Box>
            </>
          )}
          {assessmentDataError && (
            <Alert severity="error">
              <AlertTitle>Error: </AlertTitle>
              {assessmentDataError}
            </Alert>
          )}
        </Box>
      </>
    </>
  );
};

export default AssessmentList;
